import axios from "axios";
import Env from "@/logics/Envs.js";

export default async function (sessionId) {
    try {
        const params = { sessionId };
        const res = await axios.get(Env.apiPath + "deleteClassSession", { params });
        return res.data.error;
    } catch (err) {
        return err;
    }
}